import { atomWithReset } from "jotai/utils";

import type { SalesListItem } from "../types";

export const deleteSalesModalAtom = atomWithReset<{
  visible: boolean;
  data: SalesListItem | null;
}>({
  visible: false,
  data: null
});
